import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const LinkSvg = ({ color = "primary", bg, iconStyle, ...rest }) => {
  return (
    <Svg
      width="33"
      height="33"
      viewBox="-3 0 30 22.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M9.17188 14.8287L14.8287 9.17188"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M7.04672 11.293L5.63251 12.7072C4.07041 14.2693 4.07041 16.8019 5.63251 18.364C7.19461 19.9261 9.72727 19.9261 11.2894 18.364L12.7036 16.9498"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M11.2969 7.05063L12.7111 5.63642C14.2732 4.07432 16.8058 4.07432 18.3679 5.63642C19.93 7.19851 19.93 9.73117 18.3679 11.2933L16.9537 12.7075"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  )
}

export default LinkSvg
